/**
 * @license
 * Copyright 2018-2021 Streamlit Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react"
import { PageConfig } from "src/autogen/proto"
import { baseTheme, ThemeConfig } from "src/theme"

export interface Props {
  wideMode: boolean
  layout: PageConfig.Layout
  initialSidebarState: PageConfig.SidebarState
  embedded: boolean
  isFullScreen: boolean
  setFullScreen: (value: boolean) => void
  addReportFinishedHandler: (func: () => void) => void
  removeReportFinishedHandler: (func: () => void) => void
  activeTheme: ThemeConfig
  setTheme: (theme: ThemeConfig) => void
  availableThemes: ThemeConfig[]
  addThemes: (themes: ThemeConfig[]) => void
}

export default React.createContext<Props>({
  wideMode: false,
  layout: PageConfig.Layout.CENTERED,
  initialSidebarState: PageConfig.SidebarState.AUTO,
  embedded: false,
  isFullScreen: false,
  setFullScreen: (value: boolean) => {},
  addReportFinishedHandler: (func: () => void) => {},
  removeReportFinishedHandler: (func: () => void) => {},
  activeTheme: baseTheme,
  setTheme: (theme: ThemeConfig) => {},
  availableThemes: [],
  addThemes: (themes: ThemeConfig[]) => {},
})
